import * as Sentry from '@sentry/browser';

export default class Log {
  static get sentry() {
    return ['qa', 'production'];
  }

  constructor(env = 'development') {
    this.env = env;
  }

  info(msg, ...theArgs) {
    if (Log.sentry.includes(this.env)) {
      Sentry.captureMessage(msg);
    } else {
      console.log(msg, ...theArgs);
      console.trace();
    }
  }

  exception(e, rethrow = true) {
    if (Log.sentry.includes(this.env)) Sentry.captureException(e);
    else console.error(e);
    globalStore.updateErrors(e);
    if (rethrow) throw e;
  }
}
